import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconComponent } from '@core/user-interface-legacy';

type OfferKind = 'talent_pool' | 'job';

@Component({
  selector: 'rt-offer-status-indicator',
  templateUrl: './offer-status-indicator.component.html',
  styleUrls: ['./offer-status-indicator.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'className',
  },
  imports: [IconComponent],
})
export class OfferStatusIndicatorComponent {
  public showTalentPoolsIcon: boolean;
  public className: string;

  @Input()
  public set offerStatus(offerStatus: { kind: OfferKind; status: string }) {
    this.showTalentPoolsIcon = offerStatus.kind === 'talent_pool';
    this.className = offerStatus.kind === 'talent_pool' ? 'talent-pool' : offerStatus.status;
  }
}
